const authStoreSection = 'authentication';

export { authStoreSection };
